import React, { useEffect } from "react";
import "./Treasury.css";
import BannerTreasury from "../../Banner/BannerTreasury";
import TreasureOverview from "../../TreasuryBalance/TreasureOverview";
const Treasury = () => {
  return (
    <div className="">
      {/* <BannerTreasury /> */}
      <TreasureOverview />
    </div>
  );
};

export default Treasury;
